<app-header [title]="'printers.add_printer_bt_title' | translate"></app-header>
<ion-content>

</ion-content>
